<!-- login-modal.component.html -->
<div class="modal" [ngClass]="{'show': isModalVisible}" (click)="closeModal($event)">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Login with OTP</h5>
                <button type="button" class="close" (click)="closeModal()">×</button>
            </div>
            <div class="modal-body">
                <form (ngSubmit)="sendOTP()" autocomplete="off" [formGroup]="userForm" *ngIf="!isOTPsent">
                    <!-- Mobile Number Input -->
                    <div class="form-group">
                        <label for="mobileNumber">Enter Mobile No <span style="color:#00d561;">(Whatsapp)</span></label>
                        <input type="text" class="form-control" id="mobileNumber" formControlName="mobileNumber"
                            maxlength="10" placeholder="10-digit Mobile Number without +91"
                            style="text-align: center;" />

                        <div *ngIf="userForm.controls['mobileNumber'].invalid && userForm.controls['mobileNumber'].touched"
                            style="color: red;">
                            Please enter a valid 10-digit number.
                        </div>
                    </div>
                    <!-- Send OTP Button -->
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary w-100" [disabled]="userForm.invalid">Send
                            OTP</button>
                    </div>
                </form>

                <!-- OTP Input Field -->
                <!-- OTP Input Field -->
                <form (ngSubmit)="verifyOTP()" autocomplete="off" [formGroup]="otpVerifyForm" *ngIf="isOTPsent">
                    <!-- Inline success strip -->
                    <div class="otp-info-strip" *ngIf="otpInfoMessage">
                        <span class="otp-info-icon">✓</span>
                        <span class="otp-info-text">{{ otpInfoMessage }}</span>
                    </div>

                    <div class="form-group">
                        <label for="otpCode">Enter OTP</label>
                        <input type="text" class="form-control text-center" id="otpCode" formControlName="otpCode"
                            placeholder="Enter OTP" maxlength="6" />
                        <div *ngIf="otpVerifyForm.controls['otpCode'].invalid && otpVerifyForm.controls['otpCode'].touched"
                            style="color: red;">
                            Please enter the OTP sent to your mobile.
                        </div>
                    </div>

                    <!-- Terms & Conditions — shown ONLY on /share/:token pages -->
                    <div class="terms-acceptance" *ngIf="shareToken">
                        <input type="checkbox" id="acceptTerms" [(ngModel)]="termsAccepted"
                            [ngModelOptions]="{standalone: true}" aria-label="I agree to the Terms and Conditions" />
                        <a href="#" (click)="openTermsModal($event)">Terms &amp; Conditions</a>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary w-100"
                            [disabled]="otpVerifyForm.invalid || (shareToken && !termsAccepted)">Verify OTP</button>
                    </div>
                </form>


            </div>

            <div class="modal-footer d-flex justify-content-between">
                <!-- Home Button on the left -->
                <button type="button" class="btn btn-primary" (click)="navigateHome()">
                    << Home</button>
                        <!-- Close Button on the right -->
                        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            </div>

        </div>
    </div>
</div>

<div class="nda-modal" [hidden]="!isTermsModalVisible" role="dialog" aria-modal="true" aria-labelledby="ndaTitle"
    (click)="closeTermsModal()" (keydown.escape)="closeTermsModal()">
    <div class="nda-modal-content" (click)="$event.stopPropagation()">
        <div class="nda-header">
            <div>
                <h2 id="ndaTitle">BUYRENTSALE.COM</h2>
                <p>Confidentiality and Non-Disclosure Agreement</p>
            </div>
            <button #termsCloseButton type="button" class="nda-close" aria-label="Close terms and conditions"
                (click)="closeTermsModal()">&times;</button>
        </div>

        <div class="nda-body">
            <h3>CONFIDENTIALITY AND NON-DISCLOSURE AGREEMENT</h3>

            <p><strong>Between:</strong> Propify Realty Networks Pvt. Ltd.
                (“Propify”), operating BuyRentSale.com, and the individual or
                entity accepting this Agreement (“Recipient”).</p>

            <p><strong>Effective Date:</strong> Date and time of electronic acceptance.</p>

            <h4>1. Confidential Information</h4>
            <p>“Confidential Information” means non-public information disclosed,
                displayed, or made accessible through a property lead or related
                communication, including:</p>
            <ul>
                <li>Buyer requirements, seller requirements, investor enquiries,
                    and acquisition mandates.</li>
                <li>Names, mobile numbers, contact details, and identities of
                    buyers, sellers, landowners, investors, and intermediaries.</li>
                <li>Property addresses, survey numbers, exact locations, title
                    particulars, asking prices, budgets, negotiation positions,
                    and transaction status.</li>
                <li>Documents, communications, commercial proposals, referral
                    arrangements, and information about the source or chain of introduction.</li>
                <li>Other information marked confidential or reasonably understood
                    to be confidential in the circumstances.</li>
            </ul>
            <p>Confidential Information may belong to Propify, its clients,
                lead contributors, property owners, or other third parties.</p>

            <h4>2. Acknowledgement of Receipt</h4>
            <p>The Recipient acknowledges that the specific lead identified by
                its Lead ID or shared URL was accessed through BuyRentSale.com after
                authentication and acceptance of the applicable terms.</p>
            <p>The Recipient agrees that Propify may rely on its access and
                acceptance records as evidence of that event, together with other
                relevant evidence, in resolving a dispute about the source or handling
                of the lead.</p>
            <p>This acknowledgement does not establish that Propify originally
                created every item of information or that the Recipient had no prior
                knowledge of the opportunity.</p>

            <h4>3. Obligations of the Recipient</h4>
            <p>The Recipient agrees to:</p>
            <ol type="a">
                <li>Keep Confidential Information secure and restrict access to
                    persons who genuinely need it for an authorised transaction.</li>
                <li>Use the information only for the legitimate purpose for which
                    the lead was shared.</li>
                <li>Not disclose, sell, publish, or commercially redistribute
                    confidential contact details or lead information without
                    appropriate authorisation.</li>
                <li>Not falsify, conceal, or deliberately misrepresent the source
                    of the lead in order to evade an applicable contractual obligation.</li>
                <li>Not use confidential information to facilitate fraud,
                    impersonation, harassment, unlawful solicitation, or other
                    unlawful activity.</li>
                <li>Take reasonable precautions to prevent unauthorised copying,
                    disclosure, or use.</li>
            </ol>

            <h4>4. Non-Circumvention and Commercial Protection</h4>
            <p>Where the lead has facilitated a connection or transaction subject
                to an applicable commission or referral arrangement, the Recipient
                shall not knowingly circumvent Propify or the relevant introducing
                party for the purpose of avoiding that agreed obligation.</p>
            <p>This restriction applies to deliberate evasion through nominees,
                associated entities, substitute intermediaries, or concealed
                transaction structures where the facts establish that the arrangement
                was used to defeat the applicable obligation.</p>
            <p>Any commission, referral fee, or revenue share remains subject to
                the applicable written or otherwise legally enforceable commercial
                arrangement. This NDA does not independently establish an unspecified
                fee or percentage.</p>

            <h4>5. Pre-Existing Knowledge and Exceptions</h4>
            <p>The Recipient is not prohibited from using information that the
                Recipient can demonstrate:</p>
            <ol type="a">
                <li>Was lawfully known before access to the relevant lead.</li>
                <li>Was obtained independently without using the Confidential Information.</li>
                <li>Became public through no breach of this Agreement.</li>
                <li>Was lawfully received from another source without a
                    confidentiality restriction.</li>
                <li>Must be disclosed under applicable law or a lawful order,
                    subject to any legally permissible notice to the affected party.</li>
            </ol>
            <p>Where the Recipient disputes the source of a lead, the parties
                shall consider contemporaneous records and other relevant evidence
                in good faith.</p>

            <h4>6. No Unauthorised Representation</h4>
            <p>The Recipient shall not represent that they are an employee,
                agent, exclusive representative, or authorised spokesperson of
                Propify unless separately authorised in writing.</p>
            <p>Nothing in this NDA transfers ownership of a third party's
                property, personal information, or other intellectual property to
                the Recipient or Propify.</p>

            <h4>7. Return, Deletion and Retention</h4>
            <p>Upon a reasonable written request, the Recipient shall cease
                unauthorised use and, where lawful and practicable, delete or return
                confidential copies that are no longer required for the permitted
                purpose.</p>
            <p>This obligation does not require deletion of records that must
                be retained by law, are reasonably required for a legitimate dispute
                or compliance purpose, or are preserved in routine secure backups,
                provided that they remain appropriately protected.</p>

            <h4>8. Duration</h4>
            <p>The obligations under this NDA apply from electronic acceptance
                and continue for twenty-four (24) months from the relevant lead-access
                date. Trade secrets and information otherwise entitled to longer
                protection remain protected for the period required by applicable law.</p>

            <h4>9. Breach and Legal Remedies</h4>
            <p>A party alleging breach may seek remedies available under
                applicable law, subject to proof of the breach and the relevant legal
                requirements. Depending on the circumstances, remedies may include
                recovery of proven losses, enforcement of an applicable payment
                obligation, or appropriate injunctive relief.</p>
            <p>No automatic penalty or unspecified commission is created by this clause.</p>

            <h4>10. Electronic Acceptance</h4>
            <p>The Recipient agrees that an affirmative acceptance recorded
                after OTP authentication may evidence agreement to this NDA,
                subject to applicable law.</p>
            <p>Propify may retain the applicable agreement version, Lead ID,
                authenticated mobile number, acceptance timestamp, and relevant
                audit records for lawful evidentiary and compliance purposes.</p>

            <h4>11. Governing Law and Disputes</h4>
            <p>This NDA is governed by the laws of India. The parties shall
                first attempt to resolve disputes through good-faith discussions.
                Unresolved disputes may be brought before competent courts at
                Hyderabad, Telangana, subject to applicable law and jurisdictional
                requirements.</p>

            <h4>12. Acceptance</h4>
            <p>By selecting “I Agree &amp; Continue,” the Recipient confirms
                that they have had an opportunity to review this NDA, understand
                its confidentiality and non-circumvention provisions, and voluntarily
                agree to be bound by its enforceable terms.</p>

            <div class="nda-footer">
                <strong>Propify Realty Networks Pvt. Ltd.</strong><br />
                BuyRentSale.com<br />
                Contact: 9618641100<br />
                Website:
                <a href="https://buyrentsale.com/" target="_blank" rel="noopener noreferrer">
                    https://buyrentsale.com/
                </a>
            </div>
        </div>

        <div class="nda-actions">
            <button type="button" (click)="closeTermsModal()">Close</button>
        </div>
    </div>
</div>

<div class="modal fade" id="ConfirmModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content" style="padding: 20px;">
            <h3>The entered mobile number is not registered. Do you want to create new account ?</h3>
            <br />
            <div class="row">
                <div class="col-6">
                    <button (click)="hideModal()" class="btn btn-danger pull-right">No</button>
                </div>
                <div class="col-6">
                    <button (click)="SendOTPByMobile()" class="btn btn-success">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>